<template>
  <section>
    <v-layout row style="margin: 18px;">
      <v-flex md6 ma-2 d-flex color="primary" style="height:404px;">
        <app-add-category ref="UpdateCategory"></app-add-category>
      </v-flex>
      <v-flex md6 ma-2 d-flex color="primary" style="height:404px;">
        <category-table @UpdateCategory="UpdateCategory"></category-table>
      </v-flex>
    </v-layout>
  </section>
</template>
<script>
import appAddCategory from "../views/dialogs/AddCategory";
import CategoryTable from "../views/tables/CategoryTable";

export default {
  components: {
    appAddCategory,
    CategoryTable
  },
  data() {
    return {};
  },
  methods: {
    UpdateCategory(Details) {
      this.$refs.UpdateCategory.OpenToUpdate(Details);
    }
  },
  mounted(){

      this.$eventHub.$emit("LOADING",'false')
  }
};
</script>
<style scoped>
</style>

